import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getMachineGroup(page) {
  const data = await getFetch(`/MachineGroup?q=&page=${page}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeMachineGroup(form) {
  if (form.get('title') === '') {
    return {
      status: 'error',
      message: 'گروه دستگاه الزامی است!',
    }
  }

  const res = await postFetchWithToken("/MachineGroup/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'گروه دستگاه با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }
}
async function deleteMachineGroup(id) {
  const res = await postFetchWithBody(`/MachineGroup/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getMachineGroup, storeMachineGroup,deleteMachineGroup };
